'use client';
var classes = {"tooltip":"m_1b3c8819","arrow":"m_f898399f"};

export { classes as default };
//# sourceMappingURL=Tooltip.module.css.mjs.map
